import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { convertDateToCustomFormat, countDaysFromFuture, isInNextSevenDays } from '@/util/date-util';
import { USER_STATE_PAYMENT } from '@/constants';
import { InvitationCodeService } from '@/service/Invitation-code.service';

@Component({})
export default class PopupTrialUserComponent extends Vue {
  @Inject('invitationCodeService')
  private invitationCodeService: () => InvitationCodeService;

  trialPeriod: string = null;
  userState = null;
  STATE = USER_STATE_PAYMENT;
  trialDayRemain = 0;
  lastInvitee;

  get account() {
    return this.$store.getters.account;
  }

  get isGuest() {
    return this.account?.isGuest ?? false;
  }

  get isAccountReady() {
    return !!this.account;
  }

  @Watch('isAccountReady')
  onChangeIsAccountReady() {
    if (this.isAccountReady) {
      const user = this.account;
      const isShowPopup = new Date(user.endDateTrial) > new Date() ? true : false;
      if (!this.isGuest && user && user.startDateTrial && user.endDateTrial && isShowPopup) {
        const startDate = convertDateToCustomFormat(new Date(user.startDateTrial), 'yyyy.MM.dd');
        const endDate = convertDateToCustomFormat(new Date(user.endDateTrial), 'yyyy.MM.dd');
        if (user.newUser) {
          this.userState = USER_STATE_PAYMENT.NEW_USER;
        } else if (user.lastInvitee) {
          this.userState = USER_STATE_PAYMENT.INVITE_SUCCESS;
          this.lastInvitee = user.lastInvitee;
          // after show 1 time, remove lastInvitee in cache
          this.invitationCodeService().clearInviteeInCache().then();
        } else if (endDate && isInNextSevenDays(endDate)) {
          this.trialDayRemain = countDaysFromFuture(endDate);
          this.userState = USER_STATE_PAYMENT.PRO_END;
        } else if (startDate && endDate) {
          this.userState = USER_STATE_PAYMENT.EXIST_USER;
        }
        this.trialPeriod = startDate + ' ~ ' + endDate;
        const today = new Date();
        const end = new Date(endDate);
        if (this.trialPeriod && this.userState && end > today) {
          this.show(this.userState);
        }
      }
    }
  }

  mounted() {}

  show(key) {
    const val = JSON.parse(localStorage.getItem('modalState'));
    if (!val || (val && val[key] !== '1' && !this.$route.meta.hideNoticePromotion)) {
      // @ts-ignore
      window.$('#go-modal-login-move').modal({
        show: true,
        backdrop: true,
      });
    }
  }

  public get getCurrentLanguage(): string {
    return localStorage.getItem('currentLanguage');
  }

  dontShowAgain(key) {
    const modalStateVal = localStorage.getItem('modalState');
    const currValue = modalStateVal && modalStateVal != 'null' && modalStateVal != 'undefined' ? JSON.parse(modalStateVal) : {};
    currValue[key] = '1';
    localStorage.setItem('modalState', JSON.stringify(currValue));
  }

  routeToBenefit() {
    this.$router.push('pricing-plan');
  }

  routeToMyPage() {
    this.$router.push('/my-page');
  }
}
